export * from './useGetPartnerLogoBrand';
export * from './useGetPartnerLogoBrand.graphql';
export * from './useGetPartnerLogoBrand.interfaces';
